import React, { Component } from 'react'

class Dots extends Component {
    render () {
        return (
            <div className="fa fa-1x fa-circle" style={{ position: 'relative', top: -2, fontSize: 3, color: '999', marginRight: 2, marginLeft: 2}}></div>
        )
    }
}

export default Dots 